<template>
  <a-layout class="index animated fadeIn">
    <a-card :bordered="false">
      <a-form ref="ruleForm" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :scrollToFirstError="true">
        <a-row type="flex">
          <a-col :flex="4">
            <!-- <a-form-item ref="product_category_type_id" label="产品类目" name="product_category_type_id" v-if="CategoryList&&form.product_category_type_id">
              {{CategoryList.find(v=>v.id==form.product_category_type_id).title}}
            </a-form-item> -->
            <a-form-item ref="product_name" label="产品名称" name="product_name">
              {{form.product_name}}
            </a-form-item>
            <a-form-item ref="product_category_id" label="产品分类" name="product_category_id" v-if="cateList&&cateList.length&&form.product_category_type_id">
              <!-- {{form.product_category_id}} -->
              <a-cascader v-model:value="form.product_category_id" style="width:300px"   :options="cateList" disabled placeholder="产品分类" :field-names="{
                label: 'group_name',
                value: 'id',
                children: 'child',
              }" />
              <!-- {{cateList.find(v=>v.id==form.product_category_id)?cateList.find(v=>v.id==form.product_category_id).group_name:'--'}} -->
            </a-form-item>
            <a-form-item ref="image_url" label="产品图片" name="image_url">
              <div class='ant-upload-list ant-upload-list-picture-card' v-if='form.image_url.length'>
                <div class='ant-upload-list-picture-card-container' v-for="(v,k) in form.image_url" :key='k' @click="clickImg(k)">
                  <span>
                    <div class="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-picture-card">
                      <div class="ant-upload-list-item-info">
                        <img :src="info.picdomain+'/'+v" class='ant-upload-list-item-image' />
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </a-form-item>
            <a-form-item ref="product_price" label="产品价格" name="product_price">
              {{form.product_price}}
            </a-form-item>
            <a-form-item ref="market_price" label="市场定价" name="market_price">
              {{form.market_price}}
            </a-form-item>
            <a-form-item ref="product_sn" label="商品编码" name="product_sn">
              {{form.product_sn}}
            </a-form-item>
            <a-form-item ref="unit" label="产品单位" name="unit">
              {{form.unit}}
            </a-form-item>
            <a-form-item ref="bar_code" label="产品条码" name="bar_code">
              {{form.bar_code}}
            </a-form-item>
            <a-form-item ref="parameter" label="产品参数" name="parameter" v-if="form.parameter.length">
              <div style="background: #ececec; padding: 30px 15px">
                <a-card title="" :bordered="false">
                  <p class="m-b-20 s_flex_bian_c" v-for="(v, k) in form.parameter" :key="k">
                    <span>
                      {{ v[0] + "/" + v[1] }}
                    </span>
                    <a href="javascript:;">
                      <DeleteOutlined @click="() => form.parameter.splice(k, 1)" />
                    </a>
                  </p>
                </a-card>
              </div>
            </a-form-item>
            <a-form-item ref="breif" label="产品描述" name="breif">
              {{form.breif}}
            </a-form-item>
          </a-col>
          <a-col :flex="1">
            <app-warp title="商品详情">
              <template #app-content>
                <div class="app-content" v-html="form.content">
                </div>
              </template>
            </app-warp>
          </a-col>
        </a-row>

        <SmallSquare content="产品描述信息" />
        <a-form-item ref="name" label="云店商城" name="name">
          {{form.name}}
        </a-form-item>
        <!--产品规格-->
        <a-form-item ref="spec_many" label="产品规格" name="spec_many" :wrapper-col="{ span: 20}">
          <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="spec_type" checked-children="多" un-checked-children="单" disabled />
          <template v-if="spec_type">
            <a-table bordered :data-source="specGridCell" :columns="columns" :pagination='false'>
              <template #name="{ record }">
                <p class="width-50"><span v-for="(v,k) in record.propertyList" :key='k'>{{v.value}}{{record.propertyList[k+1]?'__':''}}</span></p>
              </template>
              <template #imageUrl="{ record }">
                <div>
                  <div class='ant-upload-list ant-upload-list-picture-card' v-if='record.image_url'>
                    <div class='ant-upload-list-picture-card-container'>
                      <span>
                        <div class="ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-picture-card">
                          <div class="ant-upload-list-item-info">
                            <img :src="info.picdomain+'/'+record.image_url" class='ant-upload-list-item-image' />
                          </div>
                        </div>
                      </span>
                    </div>
                  </div>

                </div>
              </template>
              <template #productSales="{ record }">
                {{record.product_sales}}
              </template>
              <template #stockNum="{ record }">
                <div class="s_flex_bian">
                  {{record.stock_num}}
                </div>
              </template>
              <template #productPrice="{ record }">
                {{record.product_price}}
              </template>
              <template #number="{ record }">
                {{record.sku_sn}}
              </template>
            </a-table>
          </template>
        </a-form-item>
        <!--产品规格结束-->
        <a-form-item ref="product_weight" label="产品重量" name="product_weight" v-if="!spec_type">
          {{form.product_weight}}
        </a-form-item>
        <!-- <a-form-item ref="stock" label="总库存" name="stock">
          {{form.stock}}
        </a-form-item> -->
        <a-form-item ref="product_sales" label="全网销量" name="product_sales">
          {{form.product_sales}}
        </a-form-item>
        <a-form-item ref="sort" label="列表排序" name="sort">
          {{form.sort}}
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
</template>
<script>
import { ref, onMounted, reactive, toRefs, inject } from "vue";
import store from "@/store";
import { message } from "ant-design-vue";
import {
  getProductCate,
  getCategoryList,
  createProduct,
  createProductSpec,
  getProductDetail,
  editProduct,
} from "@/api/product.js";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defForm = {
  product_name: "",
  name: "",
  time: [],
  product_category_id: [],
  product_price: "",
  market_price: "",
  breif: "",
  stock: "",
  product_sn: "",
  unit: "",
  bar_Code: "",
  product_sales: "",
  product_weight: "",
  point_gift: "",
  sort: "",
  content: "",
  parameter: [],
  image_url: [],
  product_category_type_id: null,
  spec_many: {},
};

export default {
  setup() {
    //pass
    const form = ref(JSON.parse(JSON.stringify({ ...defForm })));
    const state = reactive({
      info: store.state.user.info,
      typeLoading: false,
      SetStockNum: 0,
      SetPrice: 0,
      current: 0,
      content: "",
      spec_type: false,
      steps: [
        {
          title: "编辑基本信息",
        },
        {
          title: "编辑图文详情",
        },
      ],
      skusValidateForm: {
        skus: [],
      },
      CategoryList: [], //类目列表
      cateList: [], //分类列表
      dataSource: [],
      targetKeys: [],
      fileList: [],
      loading: false,
      imageUrl: "",
      previewVisible: false,
      previewImage: "",
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      rules: {
        name: [
          {
            required: true,
            message: "Please input Activity name",
            trigger: "blur",
          },
          {
            min: 3,
            max: 5,
            message: "Length should be 3 to 5",
            trigger: "blur",
          },
        ],
      },
      columns: [],
      basecolumns: [
        {
          title: "规格图片",
          dataIndex: "imageUrl",
          slots: { customRender: "imageUrl" },
        },
        {
          title: "价格(元)",
          dataIndex: "productPrice",
          slots: { customRender: "productPrice" },
        },

        {
          title: "库存",
          dataIndex: "stockNum",
          slots: { customRender: "stockNum" },
        },
        {
          title: "销量",
          dataIndex: "productSales",
          slots: { customRender: "productSales" },
        },
        {
          title: "商品编号",
          dataIndex: "number",
          slots: { customRender: "number" },
        },
        // {
        //   title: "操作",
        //   dataIndex: "actions",
        //   slots: { customRender: "actions" },
        // },
      ],
    });
    const ruleForm = ref();
    const momentTime = inject("momentTime");
    const $route = inject("$route");
    const $router = inject("$router");
    const _lodash = inject("_lodash");

    // 初始化
    const init = async () => {
      // 获取分类列表
      let result = await getProductCate().then((res) => res.data);
      let cateItem = {
        group_name: "暂不分类",
        id: 0,
      };
      result.data.unshift(cateItem);
      state.cateList = result.data;
      // 获取类目列表
      state.typeLoading = true;
      let Category = await getCategoryList().then((res) => res.data);
      if (iscode(Category)) {
        state.CategoryList = Category.data;
        state.typeLoading = false;
      } else {
        message.error(Category.msg);
        state.typeLoading = false;
      }

      // 获取页面参数
      if ($route.query.id) {
        // 获取详情
        getProductDetail($route.query.id).then((res) => {
          var result = res.data.data;
          state.spec_type = result.spec_type == 2 ? true : false;
          form.value = result;
          result.parameter.forEach((v, k) => {
            form.value.parameter[k][0] = v.name;
            form.value.parameter[k][1] = v.value;
          });
          form.value.content = result.content.content;
          var image_url = [];
          result.image.forEach((v, k) => {
            image_url[k] = v.image_url;
          });
          form.value.image_url = image_url;
          var product_category_id = [];
          state.cateList.forEach((v) => {
            if (v.id == result.product_category_id) {
              product_category_id.push(v.id);
            }
            if (v.child) {
              v.child.forEach((e) => {
                if (e.id == result.product_category_id) {
                  product_category_id = [v.id, e.id];
                }
              });
            }
          });
          form.value.product_category_id = product_category_id;

          if (result.specValue) {
            specGridCell.value = result.sku;
            skus.value = JSON.parse(result.specValue.skus);
            cretateSpace(true);
          }
        });
      }
    };
    init();
    // 添加参数
    const parameterKey = ref();
    const parameterValue = ref();
    const onParameterCreate = () => {
      if (parameterKey.value && parameterValue) {
        if (form.value.parameter.length == 50) {
          message.error("产品参数最多50个");
          return;
        }
        form.value.parameter.push([parameterKey.value, parameterValue.value]);
        parameterKey.value = "";
        parameterValue.value = "";
      } else {
        message.error("请输入参数");
      }
    };
    // 删除参数
    const skus = ref([]); //存放添加规格的表单
    const spec_many = ref(); //规格提交的数据、
    const addParameter = () => {
      if (skus.value.length >= 3) {
        message.error("规格最多输入3种");
        return;
      }
      skus.value.push({
        spec_value: [],
        spec_name: "",
        value: "",
      });
    };

    // 生成属性
    const specGridCell = ref();
    const cretateSpace = (is_detail) => {
      var spec_many = {
        spec_attr: "",
        spec_list: [],
      };
      // 过滤空白的规格
      let normlizeList = skus.value.map((item) => {
        return {
          spec_name: item.spec_name,
          spec_value: item.spec_value.filter((value) => value.name),
        };
      });
      // 获取规格数据
      if (is_detail) {
        specGridCell.value = spaceHandle(normlizeList).map((item, key) => {
          return {
            propertyList: item,
            product_price: specGridCell.value[key].product_price,
            market_price: specGridCell.value[key].market_price,
            stock_num: specGridCell.value[key].stock_num,
            product_sales: specGridCell.value[key].product_sales,
            product_weight: specGridCell.value[key].product_weight,
            image_url: specGridCell.value[key].image_url,
            sku_sn: specGridCell.value[key].sku_sn,
          };
        });
      } else {
        specGridCell.value = spaceHandle(normlizeList).map((item, key) => {
          return {
            propertyList: item,
            product_price: 0,
            market_price: 0,
            stock_num: 0,
            product_sales: 0,
            product_weight: 0,
            image_url: "",
            sku_sn: "",
          };
        });
      }
      // 整理数据
      specGridCell.value.forEach((v, key) => {
        if (v.propertyList.length) {
          v.propertyList.forEach((element, index) => {
            v["text" + index] = element.value;
          });
        }
      });
      // 动态生成表头
      var columns = [];
      normlizeList.forEach((element, key) => {
        columns.push({
          title: element.spec_name,
          dataIndex: "text" + key,
          key: "text" + key,
          customRender: ({ text }) => {
            const obj = {
              children: text,
            };
            return obj;
          },
        });
      });
      state.columns = columns.concat(state.basecolumns);
    };
    // 处理多规格数据
    const spaceHandle = (arr) => {
      function mix(item1, item2) {
        var arr1 = Array.isArray(item1.spec_value) ? item1.spec_value : item1;
        var arr2 = item2.spec_value;
        var result = [];
        for (let i = 0; i < arr1.length; i++) {
          for (let j = 0; j < arr2.length; j++) {
            let item = [];
            if (Array.isArray(arr1[i])) {
              item = item.concat(arr1[i]);
              item.push({
                name: item2.spec_name,
                value: arr2[j].name,
              });
            } else {
              item.push({
                name: item1.spec_name,
                value: arr1[i].name,
              });
              item.push({
                name: item2.spec_name,
                value: arr2[j].name,
              });
            }
            result.push(item);
          }
        }
        return result;
      }
      if (arr.length < 1) {
        return [];
      } else if (arr.length < 2) {
        let result = [];
        let item = arr[0];
        item.spec_value.map((value) => {
          result.push([
            {
              name: item.spec_name,
              value: value.name,
            },
          ]);
        });
        return result;
      } else {
        return arr.reduce((acc, item) => {
          return mix(acc, item);
        });
      }
    };
    // 批量设置价格
    const confirmSetPrice = () => {
      specGridCell.value.forEach((v) => {
        v["product_price"] = state.SetPrice;
      });
    };
    // 批量设置库存
    const confirmSetStock = () => {
      specGridCell.value.forEach((v) => {
        v["stock_num"] = state.SetStockNum;
      });
    };
    const allset = (data) => {
      specGridCell.value.forEach((v) => {
        v["product_price"] = data["product_price"];
        v["market_price"] = data["market_price"];
        v["stock_num"] = data["stock_num"];
        v["product_weight"] = data["product_weight"];
        v["image_url"] = data["image_url"];
        v["product_sales"] = data["product_sales"];
        v["sku_sn"] = data["sku_sn"];
      });
    };
    // 下一步
    const next = (step) => {
      // 第一步的校验
      if (step && step == 1) {
        if (form.value.product_category_type_id == null) {
          message.error("请选择类目");
          return;
        }
        state.current++;
      } else {
        ruleForm.value
          .validate()
          .then((res) => {
            if (state.spec_type) {
              var flag = false;
              specGridCell.value.forEach((element) => {
                for (const key in element) {
                  if (key == "image_url" && !element[key]) {
                    flag = "请完善商品图片";
                  }
                  if (key == "sku_sn" && !element[key]) {
                    flag = "请完善商品编号";
                  }
                  if (key == "product_price" && !element[key]) {
                    flag = "请完善商品价格";
                  }
                  if (key == "stock_num" && !element[key]) {
                    flag = "请完善商品库存";
                  }
                }
              });
              if (!flag) {
                state.current++;
              } else {
                message.error(flag);
              }
            } else {
              state.current++;
            }
          })
          .catch((error) => {
            message.error("请完善表单");
          });
      }
    };
    const router = inject("$router");
    const onSubmit = () => {
      ruleForm.value
        .validate()
        .then(async (e) => {
          if (state.spec_type) {
            // 多规格
          }
          var result;
          let json = {
            ...e,
            content: form.value.content,
            product_category_id:
              e.product_category_id[e.product_category_id.length - 1],
            spec_many: JSON.stringify(specGridCell.value),
            skus: JSON.stringify(skus.value),
            spec_type: state.spec_type ? 2 : 1,
          };
          if ($route.query.id) {
            result = await editProduct($route.query.id, json).then(
              (res) => res.data
            );
          } else {
            result = await createProduct(json).then((res) => res.data);
          }
          if (iscode(result, true)) {
            router.push({ path: "/product/libs/management/index" });
            setTimeout(() => {
              ruleForm.value.resetFields();
              form.value = {};
            }, 100);
          }
        })
        .catch((error) => {
          state.current--;
        });
    };
    return {
      form,
      ...toRefs(state),
      ruleForm,
      onSubmit,
      next,
      addParameter,
      skus,
      allset,
      spec_many,
      parameterKey,
      cretateSpace,
      parameterValue,
      onParameterCreate,
      specGridCell,
      confirmSetPrice,
      confirmSetStock,
    };
  },
};
</script>
<style lang="less" >
@import url("@/style/app-warp/app-warp.less");
</style>
<style lang="less" scoped>
.ant-row {
  margin-bottom: 40px;
}

.editorContent {
  display: flex;
  .detailContent {
    background-image: url("../../../../assets/images/iphone.png");
    width: 327px;
    height: 727px;
    background-repeat: no-repeat;
    background-size: contain;
    margin-right: 50px;
    word-break: break-all;
    padding: 50px 23px 10px;
  }
}

.cateItem {
  width: 195px;
  height: 73px;
  text-align: center;
  line-height: 73px;
  font-size: 20px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #333333;
  margin-right: 26px;

  > label {
    width: 195px;
    height: 73px;
    display: block;
    position: relative;
    border: 1px solid #83c8dd;
    border-radius: 5px;
    overflow: hidden;
  }

  .current {
    display: none;
    position: absolute;
    z-index: 1;
    width: 0;
    height: 0;
    line-height: 0;
    font-size: 0;
    pointer-events: none;
    border: 20px solid #83c8dd;
    border-left-color: transparent;
    border-top-color: transparent;
    right: -1px;
    bottom: -1px;

    span {
      position: absolute;
      font-size: 14px;
      color: #fff;
      margin-top: 8px;
      transform: rotate(10deg);
    }
  }

  input:checked ~ label {
    border: 1px solid #83c8dd;

    .current {
      display: block;
    }
  }
}

.otherItem {
  position: relative;
  border: 1px solid #83c8dd;
  border-radius: 5px;
  .otherList {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    display: none;
    border: 1px solid #83c8dd;
    position: absolute;
    border-top: none;
    width: 287px;
    overflow: scroll;
    height: 100px;
    right: -1px;
    top: 79px;
    box-sizing: border-box;
    transition: display 1s;
    &::before {
      content: "";
      width: 92px;
      height: 1px;
      position: absolute;
      top: 0;
      background-color: #83c8dd;
      left: 0;
    }
  }
  .ant-radio-group {
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
  }
  .white-line {
    position: absolute;
    background-color: #fff;
    right: -2px;
    top: -10px;
    width: 195px;
    height: 10px;
    box-sizing: border-box;
    border-left: 1px solid #83c8dd;
    border-right: 1px solid #83c8dd;
  }
  &:hover {
    border-bottom: none;
    height: 80px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    .otherList {
      display: block;
    }
  }
}
.ant-upload-list-item-image{
  width: 100%;
}
</style>
